import React from 'react';
import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';
import ParcelAddressSection from './ParcelAddressSection';
import ParcelContactSection from './ParcelContactSection';
import ParcelFiles from './ParcelFiles';
import ParcelInformationSection from './ParcelInformationSection';

const ParcelDetails = () => (
  <Grid container spacing={2}>
    <Grid item xs={12} md={7}>
      <Grid container spacing={2}>
        <Hidden implementation="js" mdUp>
          <Grid item xs={12}>
            <ParcelInformationSection />
          </Grid>
        </Hidden>
        <Grid item xs={12}>
          <ParcelContactSection />
        </Grid>
        <Grid item xs={12}>
          <ParcelAddressSection />
        </Grid>
      </Grid>
    </Grid>
    <Grid item xs={12} md={5}>
      <Grid container spacing={2}>
        <Hidden implementation="js" smDown>
          <Grid item xs={12}>
            <ParcelInformationSection />
          </Grid>
        </Hidden>
        <Grid item xs={12}>
          <ParcelFiles />
        </Grid>
      </Grid>
    </Grid>
  </Grid>
);

export default ParcelDetails;
